import * as React from 'react';
import type { InjectedIntlProps, FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import SectionMessage from '@atlaskit/section-message';

import { AppErrorBoundary } from 'view/error-boundary';

import messages from './messages';

type ErrorBoundaryMessageType = 'field' | 'comment' | 'comment-editor';

interface ErrorBoundarySectionMessageProps {
    type: ErrorBoundaryMessageType;
}

export const ErrorBoundarySectionMessage = injectIntl(
    ({ type, intl }: ErrorBoundarySectionMessageProps & InjectedIntlProps) => (
        <SectionMessage appearance="error">{intl.formatMessage(typeToMessage(type))}</SectionMessage>
    )
);

const typeToMessage = (type: ErrorBoundaryMessageType): FormattedMessage.MessageDescriptor => {
    if (type === 'field') {
        return messages.failedToRenderField;
    }
    if (type === 'comment') {
        return messages.failedToRenderComment;
    }
    if (type === 'comment-editor') {
        return messages.failedToRenderCommentEditor;
    }
    return messages.unknownError;
};

export interface ErrorBoundaryMessageProps {
    type: ErrorBoundaryMessageType;
    children: React.ReactElement;
}

const ErrorBoundaryMessage = ({ type, children }: ErrorBoundaryMessageProps) => {
    const renderError = React.useCallback(() => <ErrorBoundarySectionMessage type={type} />, [type]);
    return <AppErrorBoundary renderError={renderError}>{children}</AppErrorBoundary>;
};

export default ErrorBoundaryMessage;
